export default __webpack_public_path__ + "static/media/Rhythm.48c0dd59.png";